import { ID } from '@griply/types';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type RemoveCalendarSyncOptions<
  TDocRef = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  connectionId: ID;
  linkedItemId: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  updateDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void>;
  db: TDb;
  serverTimestamp: () => TFieldValue;
  deleteField: () => TFieldValue;
  arrayRemove: (...ids: ID[]) => TFieldValue;
  onWriteError: (error: unknown) => void;
};

export const removeCalendarSync = <
  TDocRef,
  TFieldValue,
  TDb = FirestoreInstance,
>(
  options: RemoveCalendarSyncOptions<TDocRef, TFieldValue, TDb>,
): void => {
  const {
    connectionId,
    linkedItemId,
    doc,
    updateDoc,
    db,
    serverTimestamp,
    deleteField,
    arrayRemove,
    onWriteError,
  } = options;

  const ref = doc(db, FirestoreCollections.ExternalConnections, connectionId);

  detachWrite(
    updateDoc(ref, {
      [`settings.calendarSettings.${linkedItemId}`]: deleteField(),
      'settings.syncedGoals': arrayRemove(linkedItemId),
      'settings.syncedLifeAreas': arrayRemove(linkedItemId),
      updatedAt: serverTimestamp(),
    }),
    onWriteError,
  );
};
